import clsx from "clsx";
import React from "react";
import { Conditional } from "web/react/components/conditional";
import LazyImage from "web/react/components/lazy-load-image/lazy-load-image";
import { View } from "web/react/emo/view/view";
import * as styles from "./product-card-image.css";

interface ProductCardImageEmoProps {
    src: string | null;
    alt: string;
    lazy: boolean;
    variant?: "primary" | "secondary";
}

export function ProductCardImageEmo({
    src,
    alt,
    lazy,
    variant,
}: ProductCardImageEmoProps): JSX.Element {
    return (
        <View
            background="placeholder"
            padding="xxs"
            className={clsx(styles.wrapper, { [styles.secondaryWrapper]: variant === "secondary" })}
        >
            <Conditional check={!src}>
                <div className={styles.noImage}></div>
            </Conditional>
            <Conditional check={!!src}>
                <Conditional check={lazy}>
                    <LazyImage
                        alt={alt}
                        src={src as string}
                        placeholder={`data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0"3E%3C/svg%3E`}
                        className={styles.image}
                    />
                </Conditional>
                <Conditional check={!lazy}>
                    <img src={src as string} alt={alt} className={styles.image} />
                </Conditional>
            </Conditional>
        </View>
    );
}
